import {SITE_CONFIGURATION} from '../../Api/resources/endPoint';
import { serviceName } from '../../Api/resources/serviceConstants';

export const getSiteConfiguration = () => {
  return {
    url: SITE_CONFIGURATION,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};
